<template>
  <div class="p-3">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-table>
          <md-table-row>
            <md-table-head>Titulo</md-table-head>
            <md-table-head>Comando</md-table-head>
            <md-table-head />
          </md-table-row>

          <md-table-row v-for="(value, key) in comandosTitulo" :key="key">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>{{ key }}</md-table-cell>
            <md-table-cell>
              <md-button
                class="md-icon-button md-accent"
                @click="() => handleRemoverComando(key)"
              >
                <md-icon>highlight_off</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-row>
            <md-table-cell>
              <md-field :class="getValidationClass('titulo')">
                <label :for="`titulo${_uid}`">Titulo</label>
                <md-input
                  :id="`titulo${_uid}`"
                  v-model="form.titulo"
                  :name="`titulo${_uid}`"
                />
                <span v-if="!$v.form.titulo.required" class="md-error"
                  >Titulo é requerido</span
                >
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-field :class="getValidationClass('comando')">
                <label :for="`comando${_uid}`">Comando</label>
                <md-input
                  :id="`comando${_uid}`"
                  v-model="form.comando"
                  :name="`comando${_uid}`"
                />
                <span v-if="!$v.form.comando.required" class="md-error"
                  >Comando é requerido</span
                >
                <span v-else-if="!$v.form.comando.length" class="md-error"
                  >Deve ter 4 caracteres</span
                >
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-button class="md-icon-button mt-3" @click="handleForm">
                <md-icon>add</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MotoBombaComandoTituloForm',
  mixins: [validationMixin],
  props: {
    initialComandosTitulo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    comandoForm: null,
    comandosTitulo: {},
    form: {
      comando: null,
      titulo: null,
    },
  }),
  validations: {
    form: {
      comando: {
        required,
        length: (value) => value.length === 4,
      },
      titulo: {
        required,
      },
    },
  },
  mounted() {
    this.comandosTitulo = { ...this.initialComandosTitulo }
  },
  methods: {
    handleForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.comandosTitulo[this.form.comando] = this.form.titulo

      this.form = {
        comando: null,
        titulo: null,
      }

      this.$v.$reset()

      this.$forceUpdate()

      this.$emit('change', { ...this.comandosTitulo })
    },
    handleRemoverComando(key) {
      delete this.comandosTitulo[key]

      this.$forceUpdate()

      this.$emit('change', { ...this.comandosTitulo })
    },
  },
}
</script>
